import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FullLoader } from "../../../components/loader";
import styles from "./paymentResponse.module.scss";

// Import payment status images
import paymentSuccessImage from "../../../assets/images/paymentSuccessImage.png";
import paymentFailedImage from "../../../assets/images/paymentFailedImage.png";

const PaymentResponse = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    // Parse URL parameters or state from GetePay response
    const urlParams = new URLSearchParams(location.search);
    const state = location.state;

    // Simulate processing time
    setTimeout(() => {
      // Extract payment information from URL parameters or state
      const transactionId = urlParams.get("txnid") || state?.transactionId;
      const status = urlParams.get("status") || state?.status;
      const amount = urlParams.get("amount") || state?.amount;
      const merchantId = urlParams.get("mid") || state?.merchantId;
      const orderId = urlParams.get("orderid") || state?.orderId;
      const paymentMode = urlParams.get("mode") || state?.paymentMode;
      const bankRefNum = urlParams.get("bank_ref_num") || state?.bankRefNum;

      // Determine success/failure based on status
      const success =
        status === "SUCCESS" ||
        status === "TXN_SUCCESS" ||
        status === "success";

      setPaymentData({
        transactionId,
        status,
        amount,
        merchantId,
        orderId,
        paymentMode,
        bankRefNum,
        timestamp: new Date().toLocaleString(),
      });

      setIsSuccess(success);
      setLoading(false);
    }, 2000);
  }, [location]);

  const handleReturnHome = () => {
    navigate("/app/dashboard");
  };

  const handleRetryPayment = () => {
    navigate(-1); // Go back to previous page
  };

  const handleDownloadReceipt = () => {
    // Implement receipt download functionality
    console.log(
      "Download receipt for transaction:",
      paymentData?.transactionId,
    );
  };

  if (loading) {
    return <FullLoader />;
  }

  return (
    <div className={styles.paymentResponseContainer}>
      <div className={styles.containerFluid}>
        <div className={styles.centerWrapper}>
          <div className={styles.responseCard}>
            <div className={styles.cardBody}>
              <div className={styles.row}>
                {/* Image Section */}
                <div className={styles.imageSection}>
                  <div className={styles.imageWrapper}>
                    <img
                      src={isSuccess ? paymentSuccessImage : paymentFailedImage}
                      alt={isSuccess ? "Payment Success" : "Payment Failed"}
                      className={styles.statusImage}
                    />
                  </div>
                </div>

                {/* Details Section */}
                <div className={styles.detailsSection}>
                  <div className={styles.statusHeader}>
                    <h2
                      className={
                        isSuccess ? styles.successTitle : styles.failureTitle
                      }
                    >
                      {isSuccess ? "Payment Successful!" : "Payment Failed!"}
                    </h2>
                    <p className={styles.statusMessage}>
                      {isSuccess
                        ? "Your payment has been processed successfully."
                        : "We encountered an issue processing your payment."}
                    </p>
                  </div>

                  {/* Payment Details */}
                  <div className={styles.paymentDetails}>
                    <h5>Transaction Details</h5>

                    {paymentData?.transactionId && (
                      <div className={styles.detailRow}>
                        <span className={styles.label}>Transaction ID:</span>
                        <span className={styles.value}>
                          {paymentData.transactionId}
                        </span>
                      </div>
                    )}

                    {paymentData?.orderId && (
                      <div className={styles.detailRow}>
                        <span className={styles.label}>Order ID:</span>
                        <span className={styles.value}>
                          {paymentData.orderId}
                        </span>
                      </div>
                    )}

                    {paymentData?.amount && (
                      <div className={styles.detailRow}>
                        <span className={styles.label}>Amount:</span>
                        <span className={styles.value}>
                          ₹{paymentData.amount}
                        </span>
                      </div>
                    )}

                    {paymentData?.paymentMode && (
                      <div className={styles.detailRow}>
                        <span className={styles.label}>Payment Mode:</span>
                        <span className={styles.value}>
                          {paymentData.paymentMode}
                        </span>
                      </div>
                    )}

                    {paymentData?.bankRefNum && (
                      <div className={styles.detailRow}>
                        <span className={styles.label}>Bank Reference:</span>
                        <span className={styles.value}>
                          {paymentData.bankRefNum}
                        </span>
                      </div>
                    )}

                    <div className={styles.detailRow}>
                      <span className={styles.label}>Status:</span>
                      <span
                        className={`${styles.value} ${isSuccess ? styles.successStatus : styles.failureStatus}`}
                      >
                        {isSuccess ? "Success" : "Failed"}
                      </span>
                    </div>

                    <div className={styles.detailRow}>
                      <span className={styles.label}>Date & Time:</span>
                      <span className={styles.value}>
                        {paymentData?.timestamp}
                      </span>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className={styles.actionButtons}>
                    {/* <button
                        className={styles.primaryButton}
                        onClick={handleDownloadReceipt}
                      >
                        Download Receipt
                      </button> */}
                    <button
                      className={styles.secondaryButton}
                      onClick={handleReturnHome}
                    >
                      Return to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentResponse;
